import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import * as React from "react";
import styled from "../../styled-components";
import SearchResultItem from "../SearchBox/SearchResultItem";
import { SearchResultsWrap } from "../SearchBox/searchbox.elements";
export default function UserSearchResults(a) {
  var b = a.show,
      c = a.results,
      d = a.indexError,
      e = a.activeItemIdx,
      f = a.loading,
      g = a.query;
  return /*#__PURE__*/React.createElement(SearchResultsWrap, {
    show: b
  }, d && "development" === process.env.NODE_ENV && /*#__PURE__*/React.createElement(Message, null, "Failed to load search index. Search index is not working in develop. ", /*#__PURE__*/React.createElement("br", null), "Try running ", /*#__PURE__*/React.createElement("code", null, "yarn build"), " to build the search index"), 0 === c.length && !f && /*#__PURE__*/React.createElement(Message, null, " Nothing Found "), c.map(function (a, b) {
    return /*#__PURE__*/React.createElement(SearchResultItem, {
      key: a.link,
      item: a,
      query: g,
      active: b === e
    });
  }));
}
var Message = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  color: ", ";\n  padding: 1.5em;\n  @media only screen and (max-width: ", ") {\n    padding: 0.75em;\n  }\n"])), function (a) {
  return a.theme.colors.primary.main;
}, function (_ref) {
  var a = _ref.theme;
  return a.breakpoints.medium;
});